import React from 'react';
import PropTypes from 'prop-types';

import MetaDataNodeView from '../MetaDataNodeView';

import './style.scss';

const MetaDataNode = (props) => {
  const { isFullText, node, children, showIcon, nodeLevel } = props;

  let nodes;
  if (children !== undefined) {
    const childNodeLevel = nodeLevel + 1;
    nodes = children.map((nodeItem) => (
      <MetaDataNode
        nodeLevel={childNodeLevel}
        showIcon
        node={nodeItem}
        children={nodeItem.tags}
        isFullText={isFullText}
        key={nodeItem.tag_id}
      />
    ));
  }

  return (
    <MetaDataNodeView
      node={node}
      nodes={nodes}
      isFullText={isFullText}
      iconSize="0.5em"
      iconName="filled_circle"
      showIcon={showIcon}
      nodeLevel={nodeLevel}
    />
  );
};

MetaDataNode.propTypes = {
  node: PropTypes.object.isRequired,
  isFullText: PropTypes.bool.isRequired,
  showIcon: PropTypes.bool.isRequired,
  children: PropTypes.array,
  nodeLevel: PropTypes.number,
};

MetaDataNode.defaultProps = {
  classNamePrefix: '',
  children: [],
  nodeLevel: 0,
};

export default MetaDataNode;
